/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, memo } from "react";
import { Row, Col, Input, Form, Button, Table, Spin, message } from "antd";
import "./style.scss";
import API from "../../../api";
import urls from "../../../api/urls";
import {
  capitalize,
  checkAlphabets,
  checkSpace,
  checkSpecialCharacter,
  commonSorterForTable,
  firstLetterCapitalise,
  serialNum,
  showErrorMessage,
} from "../../../utils";
import Heading from "../../../components/Heading";
import { useLocation, useParams } from "react-router-dom";

import UpdateIcon from "../../../assests/images/updateEway.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";

import whiteUpdateIcon from "../../../assests/images/whiteUpdateEway.svg";
// import MainEwayBill from "../EwayBillMain";
import { getModifiedGST, formattedToday } from "..";
import search_icon from "../../../assests/images/search-icon.svg";
import { useNavigate } from "react-router-dom";

const {
  CONSOLIDATE_EWAY_BILL,
  EWAYBILL_UPDATE_PARTB,
  AUDIT_EWAY_BILL,
  SORT_CP_UPDATED_EWAY_BILL,
  HUB_MANIFEST_LIST,
  HUB_LOCK_MANIFEST,
  UPDATE_LASTMILE_EWAYS,
  UPDATE_TRANSPORTER_ID
} = urls;
//filter eway bill
const getUniqueByEwayBillNumber = (data) => {
  const seen = new Set();
  return data.filter(item => {
    if (seen.has(item.ewayBillNumber)) return false;
    seen.add(item.ewayBillNumber);
    return true;
  });
};

const CPWiseHubManifestEWayBill = () => {
  const [form] = Form.useForm();
  const params = useParams();

  const history = useLocation();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [dataSource, setdataSource] = useState(tableData);

  const userId = JSON.parse(localStorage.getItem("userId"));
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [updatedEwayData, setUpdatedEwayData] = useState([]);
  const [vehicleNum, setVehicleNum] = useState("");
  const [transPortMode, setTransPortMode] = useState("surface");
  const [inputSearchValue, setInputSearchValue] = useState("");

  const [enableLockManifest, setEnableLockManifest] = useState(true);
  const [sortedInfo, setSortedInfo] = useState({});
  const [apiDone, setApiDone] = useState(false);

  const fromThreePLTab = history?.state?.fromTab === 3;

  const didRun = React.useRef(false);

  useEffect(() => {
    if (!didRun.current) {
      getUpdatedEwayBills();
      didRun.current = true;
    }
  }, []);

  // Call getEwayBills directly after updating updatedEwayData in getUpdatedEwayBills

  // Memoized custom cell components
  const DestinationCPCell = memo(({ value }) => <div>{capitalize(value) || "NA"}</div>);
  DestinationCPCell.displayName = "DestinationCPCell";
  const ModeCell = memo(({ value }) => <div>{capitalize(value) || "NA"}</div>);
  ModeCell.displayName = "ModeCell";
  const ActionsCell = memo(({ data, navigate, params, history, form, transPortMode, SingleConsolidate, UPDATE_TRANSPORTER_ID_SINGLE_CONSOLIDATE, fromThreePLTab }) => (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {data.ewayUpdated ? (
        <>
          <Button
            className=""
            style={{
              borderRadius: "5px",
              color: "white",
              background: "#149D11",
              cursor: "not-allowed",
            }}
          >
            <img src={whiteUpdateIcon} />
            <span className="ml-1 fw-500">{fromThreePLTab ? "UPDATED TRANSPORTER ID" : "E-WAY BILL UPDATED"}</span>
          </Button>
          <Button
            className=""
            style={{
              borderRadius: "5px",
              color: "#2E77D0",
              background: "white",
            }}
            onClick={() =>
              navigate("/print-eway-bill", {
                state: {
                  state: data?.awbNumber,
                  key: "CP_EWAYBILL",
                  slug: "/cp-wise-Eway/" + params.id,
                  singleEwayBill: true,
                  data: history?.state,
                },
              })
            }
          >
            <span className="fw-500">PRINT</span>
          </Button>
        </>
      ) : (
        <Button
          className=""
          style={{
            borderRadius: "5px",
            color: "#2E77D0",
            background: "white",
          }}
          onClick={() => {
            console.log("CPWiseHubManifestEWayBill ActionsCell click data:", data);
            console.log("CPWiseHubManifestEWayBill ActionsCell click data22:", params.tplTransporterId);
            return fromThreePLTab ? UPDATE_TRANSPORTER_ID_SINGLE_CONSOLIDATE(data) : SingleConsolidate(data);
          }}
        >
          <img src={UpdateIcon} />
          <span className="ml-1 fw-500">{fromThreePLTab ? "UPDATE TRANSPORTER ID" : "E-WAY BILL UPDATE"}</span>
        </Button>
      )}
    </div>
  ));
  ActionsCell.displayName = "ActionsCell";

  const columns = [
    {
      title: "SI No",
      dataIndex: "",
      key: "SI",
      width: 15,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      width: 10,
    },
    {
      title: "AWb No",
      dataIndex: "awbNumber",
      key: "awbNumber",
      width: 40,
      render: (text) => {
        return text;
      },
    },
    {
      title: "E-way Bill No",
      width: 30,
      dataIndex: "ewayBillNumber",
      key: "ewayBillNumber",
    },
    {
      title: "Destination CP",
      width: 40,
      dataIndex: "destinationCpName",
      key: "destinationCpName",
      sorter: (a, b) => commonSorterForTable(a, b, "destinationCpName"),
      sortOrder:
        sortedInfo?.columnKey === "destinationCpName"
          ? sortedInfo?.order
          : null,
      ellipsis: true,
      render: (value) => <DestinationCPCell value={value} />,
    },
    {
      title: "Mode",
      width: 40,
      dataIndex: "travelBy",
      key: "travelBy",
      render: (value) => <ModeCell value={value} />,
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      width: 60,
      render: (_record, data) => (
        <ActionsCell
          data={data}
          navigate={navigate}
          params={params}
          history={history}
          form={form}
          transPortMode={transPortMode}
          SingleConsolidate={SingleConsolidate}
          UPDATE_TRANSPORTER_ID_SINGLE_CONSOLIDATE={UPDATE_TRANSPORTER_ID_SINGLE_CONSOLIDATE}
          fromThreePLTab={fromThreePLTab}
        />
      ),
    },
  ];

  // Change getEwayBills to accept updatedEwayDataParam
  const getEwayBills = async (e, updatedEwayDataParam) => {
    setLoading(true);
    setApiDone(false);
    const response = await API.Api(
      HUB_MANIFEST_LIST + `/${params.id}`
    ).getWithAllHeaders();

    if (response) {
      const res = response?.response?.data;
      const temp = [...res];

      // Use the passed param or fallback to state
      const effectiveUpdatedEwayData = updatedEwayDataParam || updatedEwayData;
      //console.time("EwayUpdated Processing");
      //console.log("effectiveUpdatedEwayData:", JSON.stringify(effectiveUpdatedEwayData, null, 2));
      const updatedSet = new Set(effectiveUpdatedEwayData.map(data => data.ewaybillNo));
      // Ensure all rows have the correct ewayUpdated status
      for (let i = 0; i < temp?.length; i++) {
        temp[i].ewayUpdated = updatedSet.has(temp[i].ewayBillNumber);
      }
      console.timeEnd("EwayUpdated Processing");

      setTableData(getUniqueByEwayBillNumber(temp));
      setTransPortMode("surface");
      setApiDone(true);
    } else {
      setApiDone(true);
      setLoading(false);
    }
  };

  // Hide loader only after API is done and tableData is set (even if empty)
  React.useEffect(() => {
    if (apiDone) {
      setLoading(false);
    }
  }, [apiDone, tableData]);

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: record.ewayUpdated,
      name: record.name,
    }),
    selectedRowKeys: selectedRowKeys,
  };

  const handleSubmit = async (params) => {
    setLoading(true);
    const stateGST = getModifiedGST(userId);

    if (selectedRowKeys?.length > 0) {
      let temp = selectedRowKeys?.map((val) => {
        return { ewbNo: val };
      });

      let payload = {
        fromPlace: userId?.premises?.city,
        fromState: +stateGST,
        // vehicleNo: "KA32P1275" || params?.vehicleNo,
        vehicleNo: form.getFieldValue("vehicleNo"),
        transMode: transPortMode == "surface" ? "1" : "3",
        transDocDate: params.transDocDate,
        tripSheetEwbBills: temp,
      };

      let response = await API.Api(CONSOLIDATE_EWAY_BILL).postIdHeader(payload);

      if (response?.response?.data?.status == "1") {
        if (typeof response?.response?.data?.data === "string" && typeof JSON.parse(response?.response?.data?.data) !== "object") {
          setLoading(false);
          showErrorMessage(response?.response?.data?.message || "Failed to Update E-way bill");
          return;
        }
        setLoading(false);
        /* message.success(
           response?.response?.data?.message || "E-way Bill Updated Successfully"
         );*/
        if (response?.response?.data.failedEwayBills?.length > 0) {
          let failedEwayBills = response?.response?.data?.failedEwayBills;
          let failedEwayBillNumbers = failedEwayBills?.map((item) => item.ewbNo);
          let EwayBillData = selectedRowKeys.filter((item) => !failedEwayBillNumbers?.includes(item));
          auditEwayBill(response?.response?.data, EwayBillData, "consolidate");
        } else {
          auditEwayBill(response?.response?.data, selectedRowKeys, "consolidate");
        }
        setSelectedRowKeys([]);
      } else {
        setLoading(false);
        showErrorMessage(response?.response?.data?.data || "Failed to Update E-way bill");
      }
    } else {
      showErrorMessage("Select an E-way bill");
      setLoading(false);
    }
  };

  async function SingleConsolidate(record) {
    setLoading(true);

    const stateGST = getModifiedGST(userId);

    let payload = {
      vehicleNo: form.getFieldValue("vehicleNo"),
      fromPlace: userId?.premises?.city,
      fromState: +stateGST,
      transDocDate: formattedToday,
      ewbNo: record.ewayBillNumber,
      transMode: transPortMode == "surface" ? "1" : "3",
    };

    try {
      let response = await API.Api(
        EWAYBILL_UPDATE_PARTB + record.ewayBillNumber + "/partB"
      ).patchIdHeader(payload);

      if (response?.response?.data?.status == "1") {
        // Immediately update the specific table row
        setTableData(prev =>
          prev.map(row =>
            row.ewayBillNumber === record.ewayBillNumber
              ? { ...row, ewayUpdated: true }
              : row
          )
        );

        // Update the updatedEwayData to maintain consistency
        setUpdatedEwayData(prev => {
          const exists = prev.find(item => item.ewaybillNo === record.ewayBillNumber);
          if (!exists) {
            return [...prev, { ewaybillNo: record.ewayBillNumber }];
          }
          return prev;
        });

        // Show success message
        message.success(
          response?.response?.data?.message || "E-way Bill Updated Successfully"
        );

        // Call auditEwayBill for backend consistency WITHOUT reloading the table
        await auditEwayBillWithoutReload(response?.response?.data, record, "single");
      } else {
        showErrorMessage(response?.response?.data?.data || "Failed to Update E-way bill");
      }
    } catch (error) {
      console.error("Error updating e-way bill:", error);
      showErrorMessage("Network error occurred while updating e-way bill");
    } finally {
      setLoading(false);
    }
  }
  async function UPDATE_TRANSPORTER_ID_SINGLE_CONSOLIDATE(record) {
    setLoading(true);
    let payload = {
      ewbNo: record.ewayBillNumber,
      transporterId: record.tplTransporterId,
    };

    try {
      let response = await API.Api(UPDATE_TRANSPORTER_ID
      ).post(payload);
      if (response?.response?.data?.status == "1") {
        // Immediately update the specific table row
        setTableData(prev =>
          prev.map(row =>
            row.ewayBillNumber === record.ewayBillNumber
              ? { ...row, ewayUpdated: true }
              : row
          )
        );

        // Update the updatedEwayData to maintain consistency
        setUpdatedEwayData(prev => {
          const exists = prev.find(item => item.ewaybillNo === record.ewayBillNumber);
          if (!exists) {
            return [...prev, { ewaybillNo: record.ewayBillNumber }];
          }
          return prev;
        });

        // Show success message
        message.success(
          response?.response?.data?.message || "Transporter ID Updated Successfully"
        );

        // Call auditEwayBill for backend consistency WITHOUT reloading the table
        await auditEwayBillWithoutReload(response?.response?.data, record, "single");
      } else {
        showErrorMessage(response?.response?.data?.data || "Failed to Update Transporter ID");
      }
    } catch (error) {
      console.error("Error updating e-way bill:", error);
      showErrorMessage("Network error occurred while updating e-way bill");
    } finally {
      setLoading(false);
    }
  }

  // Keep the original auditEwayBill function for consolidate updates
  async function auditEwayBill(singleUpdateRes, record, type) {
    setLoading(true);

    function filterDataByAwbNumbers(dataArray, awbNumbersArray) {
      return dataArray?.filter((item) =>
        awbNumbersArray?.includes(item?.ewayBillNumber)
      );
    }

    let temp = [];
    let payload = {};

    let x = singleUpdateRes?.data;
    let cNum = JSON?.parse(x);

    if (type == "single") {
      temp = tableData?.filter(
        (val) => val?.ewayBillNumber === record.ewayBillNumber
      );

      payload = {
        shipments: temp?.map((val) => {
          return {
            awbnumber: val?.awbNumber,
            ewaybillNo: val?.ewayBillNumber,
            ewayBillCrtDate: val?.ewayBillCreateDate || null,
            ewbBillExpDate: val?.expiryDate,
            awbcrtDate: val?.bookingStartTime,
            shipmentValue: val?.value,
          };
        }),
        manifestId: history?.state?.manifestId,
        consEwbNo: "0",
        vehicleNo: vehicleNum,
        transMode: "surface",
        ewbOprPlace: userId?.premises?.city,
      };
    } else {
      let filteredData = filterDataByAwbNumbers(tableData, record);
      temp = filteredData?.map((val) => val);

      payload = {
        shipments: temp?.map((val) => {
          return {
            awbnumber: val?.awbNumber,
            ewaybillNo: val?.ewayBillNumber,
            ewayBillCrtDate: val?.ewayBillCreateDate || null,
            ewbBillExpDate: val?.expiryDate,
            awbcrtDate: val?.bookingStartTime,
            shipmentValue: val?.value,
          };
        }),
        manifestId: history?.state?.manifestId,
        consEwbNo: cNum?.cEwbNo,
        vehicleNo: form.getFieldValue("vehicleNo"),
        transMode: "surface",
        ewbOprPlace: userId?.premises?.city,
      };
    }

    let response = await API.Api(AUDIT_EWAY_BILL).postIdHeader(payload);

    if (response.status) {
      setLoading(false);
      if (type == "single") {
        updateEwayBills(temp, null);
      } else {
        updateEwayBills(temp, cNum?.cEwbNo);
      }
    } else {
      setLoading(false);
      showErrorMessage("Internal server error");
    }
  }

  // Original updateEwayBills function for consolidate updates (with table reload)
  const updateEwayBills = async (data, cEwbNo) => {
    setLoading(true);

    let payload = {
      ewayBillList: data.map((val) => +val.ewayBillNumber),
      consolidatedEwayBill: cEwbNo || null,
    };

    let response = await API.Api(
      UPDATE_LASTMILE_EWAYS + params?.id
    ).putCustomHeader(payload);

    if (response?.status) {
      setLoading(false);
      getUpdatedEwayBills(); // This reloads the table for consolidate updates
    } else {
      setLoading(false);
      showErrorMessage(response?.response?.data?.data || "Failed to Update E-way bill");
    }
  };

  // New function that doesn't reload the table for single updates
  async function auditEwayBillWithoutReload(singleUpdateRes, record, type) {
    setLoading(true);

    function filterDataByAwbNumbers(dataArray, awbNumbersArray) {
      return dataArray?.filter((item) =>
        awbNumbersArray?.includes(item?.ewayBillNumber)
      );
    }

    let temp = [];
    let payload = {};

    let x = singleUpdateRes?.data;
    let cNum = JSON?.parse(x);

    if (type == "single") {
      temp = tableData?.filter(
        (val) => val?.ewayBillNumber === record.ewayBillNumber
      );

      payload = {
        shipments: temp?.map((val) => {
          return {
            awbnumber: val?.awbNumber,
            ewaybillNo: val?.ewayBillNumber,
            ewayBillCrtDate: val?.ewayBillCreateDate || null,
            ewbBillExpDate: val?.expiryDate,
            awbcrtDate: val?.bookingStartTime,
            shipmentValue: val?.value,
          };
        }),
        manifestId: history?.state?.manifestId,
        consEwbNo: "0",
        vehicleNo: vehicleNum,
        transMode: "surface",
        ewbOprPlace: userId?.premises?.city,
      };
    } else {
      let filteredData = filterDataByAwbNumbers(tableData, record);
      temp = filteredData?.map((val) => val);

      payload = {
        shipments: temp?.map((val) => {
          return {
            awbnumber: val?.awbNumber,
            ewaybillNo: val?.ewayBillNumber,
            ewayBillCrtDate: val?.ewayBillCreateDate || null,
            ewbBillExpDate: val?.expiryDate,
            awbcrtDate: val?.bookingStartTime,
            shipmentValue: val?.value,
          };
        }),
        manifestId: history?.state?.manifestId,
        consEwbNo: cNum?.cEwbNo,
        vehicleNo: form.getFieldValue("vehicleNo"),
        transMode: "surface",
        ewbOprPlace: userId?.premises?.city,
      };
    }

    let response = await API.Api(AUDIT_EWAY_BILL).postIdHeader(payload);

    if (response.status) {
      setLoading(false);
      if (type == "single") {
        // For single update, just update the backend without reloading
        await updateEwayBillsWithoutReload(temp, null);
      } else {
        await updateEwayBillsWithoutReload(temp, cNum?.cEwbNo);
      }
    } else {
      setLoading(false);
      showErrorMessage("Internal server error");
    }
  }

  // New function that updates backend without reloading table
  const updateEwayBillsWithoutReload = async (data, cEwbNo) => {
    setLoading(true);

    let payload = {
      ewayBillList: data.map((val) => +val.ewayBillNumber),
      consolidatedEwayBill: cEwbNo || null,
    };

    let response = await API.Api(
      UPDATE_LASTMILE_EWAYS + params?.id
    ).putCustomHeader(payload);

    if (response?.status) {
      setLoading(false);
      // Don't call getUpdatedEwayBills() here - this prevents table reload
    } else {
      setLoading(false);
      showErrorMessage(response?.response?.data?.data || "Failed to Update E-way bill");
    }
  };

  // In getUpdatedEwayBills, pass the fresh data to getEwayBills
  const getUpdatedEwayBills = async () => {
    setLoading(true);
    try {
      let response = await API.Api(
        `${SORT_CP_UPDATED_EWAY_BILL}${params?.id}`
      ).getWithAllHeaders();

      console.log("getUpdatedEwayBillsCalling");

      if (response?.status) {
        // Update the updatedEwayData with the latest data from backend
        const updatedEwayBills = response?.response?.data?.ewaybill || [];
        setUpdatedEwayData(updatedEwayBills);

        // Now call getEwayBills to refresh the table with updated status, passing the fresh data
        await getEwayBills(null, updatedEwayBills);
      } else {
        console.error("Failed to fetch updated e-way bills");
      }
    } catch (error) {
      console.error("Error fetching updated e-way bills:", error);
    } finally {
      setLoading(false);
    }
  };

  // Add a useEffect to ensure updatedEwayData is properly synced when component mounts
  useEffect(() => {
    if (updatedEwayData.length > 0 && tableData.length > 0) {
      // Re-apply the ewayUpdated status to ensure consistency
      setTableData(prev =>
        prev.map(row => ({
          ...row,
          ewayUpdated: updatedEwayData.some(updated => updated.ewaybillNo === row.ewayBillNumber)
        }))
      );
    }
  }, [updatedEwayData]);

  const filterArray = (data, currValue) => {
    return data?.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(currValue.toLowerCase())
      )
    );
  };

  const onSearch = (e) => {
    const currValue = e.target.value;
    setInputSearchValue(currValue);

    const filteredData =
      inputSearchValue.length > 0 || inputSearchValue.length == 0
        ? filterArray(tableData, currValue)
        : filterArray(tableData, currValue);
    setdataSource(filteredData);
  };

  async function handleLockManifest() {
    setLoading(true);

    const payload = {
      // status: "LOCKED",
      status: "LOCKED",
      vehicleNumber: form?.vehicleNo || "",
      driverName: form?.driverName || "",
    };
    let response = await API.Api(HUB_LOCK_MANIFEST + params?.id).putIdHeader(
      payload
    );

    if (response.status) {
      setLoading(false);
      message.success("Manifest locked successfully");
      getUpdatedEwayBills();
    } else {
      showErrorMessage("Network error");
      setLoading(false);
    }
  }

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  // console.log(history?.state?.driverName, "history");

  const prevTableDataRef = useRef([]);

  useEffect(() => {
    if (prevTableDataRef.current.length > 0) {
      // Find rows that were not updated before but are now updated
      const newlyUpdated = tableData.filter(row => {
        const prevRow = prevTableDataRef.current.find(r => r.ewayBillNumber === row.ewayBillNumber);
        return prevRow && !prevRow.ewayUpdated && row.ewayUpdated;
      });
      if (newlyUpdated.length > 0) {
        message.success("E-way Bill updated successfully!");
      }
    }
    prevTableDataRef.current = tableData;
  }, [tableData]);

  return (
    <Spin
      spinning={loading}
      indicator={<img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />}
    >
      <div className="m-2">
        <Heading
          title={"Manifest E-way Bil"}
          navigateTo={{
            pathname: "/generateManifest",
            search: history?.state?.fromTab ? `?tab=${history?.state?.fromTab}` : "?tab=2",
            state: {
              cpId: history?.state?.cpId || null,
              dateRange: history?.state?.dateRange || null
            }
          }}
        />
        <div className="hub-manifest-container p-2">
          <Form
            form={form}
            onFinish={handleSubmit}
            name="accountBasicDetails"
            layout="vertical"
            initialValues={{
              transDocDate: formattedToday,
              manifestId: params?.id,
              driverName: history?.state?.driverName || "",
              vehicleNo: history?.state?.vehicleNumber || "",
            }}
            scrollToFirstError={{
              behavior: "smooth",
              block: "center",
              inline: "center",
            }}
          >
            {tableData?.length ? (
              <>
                <Row justify="center" gutter={16} className="m-1">
                  <Col span={8} sm={24} md={8} lg={8} xs={24}>
                    <Form.Item
                      // initialValue={"bottom"}
                      name="transDocDate"
                      label="Date"
                      rules={[
                        {
                          required: false,
                          message: "Select date",
                        },
                      ]}
                    >
                      <Input placeholder="Date" disabled />
                    </Form.Item>
                  </Col>

                  <Col span={8} sm={24} md={8} lg={8} xs={24}>
                    <Form.Item
                      name="manifestId"
                      label="Manifest Id"
                      value={params?.id}
                      rules={[
                        {
                          required: false,
                          message: "Enter manifest Id",
                        },
                      ]}
                    >
                      <Input disabled placeholder="Enter Manifest Id" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify="center" gutter={16} className="m-1">
                  <Col span={8} sm={24} md={8} lg={8} xs={24}>
                    <Form.Item
                      name="driverName"
                      label="Driver name"
                      rules={[
                        {
                          required: true,
                          message: "Please enter driver name",
                        },
                        () => ({
                          validator(_rule, value = "") {
                            if (value.substring(1, 0) === " ") {
                              return Promise.reject("Please enter valid name");
                            } else {
                              return Promise.resolve();
                            }
                          },
                          validateTrigger: "onSubmit",
                        }),
                      ]}
                    >
                      <Input
                        maxLength={30}
                        placeholder="Enter driver name"
                        onKeyPress={(event) => {
                          if (checkAlphabets(event)) {
                            event.preventDefault();
                          }
                        }}
                        onInput={(e) =>
                          (e.target.value = firstLetterCapitalise(e))
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8} sm={24} md={8} lg={8} xs={24}>
                    <Form.Item
                      name="vehicleNo"
                      label={"Vehicle number"}
                      rules={[
                        {
                          required: true,
                          message: "Enter vehicle number",
                        },
                      ]}
                      onKeyPress={(event) => {
                        if (checkSpecialCharacter(event) || checkSpace(event)) {
                          event.preventDefault();
                        }
                      }}
                    >
                      <Input
                        style={{ textTransform: "uppercase" }}
                        placeholder="Example:KA32F2622"
                        // disabled
                        onBlur={(e) => {
                          form.setFieldValue(
                            "vehicleNo",
                            e.target.value.toUpperCase()
                          );
                        }}
                        maxLength={12}
                        onChange={(e) => setVehicleNum(e.target.value)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify="end">
                  {!fromThreePLTab && (
                    <Button
                      className="save-btn"
                      htmlType="submit"
                    // onClick={form.submit}
                    >
                      CONSOLIDATE UPDATE
                    </Button>
                  )}
                </Row>
              </>
            ) : (
              <Row justify="end">
                <h2 style={{ margin: "auto" }}>No E-way bills present</h2>
              </Row>
            )}
          </Form>
        </div>

        <div className="p-1 hub-eway-container">
          <Input
            placeholder="Search by AWB, Eway number"
            bordered
            onChange={onSearch}
            style={{
              borderRadius: "5px",
              height: "40px",
              maxWidth: "250px",
              marginBottom: "20px",
            }}
            suffix={<img src={search_icon} />}
          />
          <Table
            // onChange={onSelectChange}
            columns={columns}
            onChange={handleChange}
            scroll={{ x: 500 }}
            dataSource={inputSearchValue.length == 0 ? tableData : dataSource}
            // dataSource={[]}
            pagination={{ pageSize: 50 }}
            rowKey={(record) => record?.ewayBillNumber}
            rowSelection={{
              ...rowSelection,
            }}
          />
        </div>

        <Row justify="end mt-2">
          <Button
            className="save-btn"
            htmlType="submit"
            disabled={enableLockManifest}
            onClick={handleLockManifest}
          >
            LOCK MANIFEST
          </Button>
        </Row>
      </div>
    </Spin>
  );
};
export default CPWiseHubManifestEWayBill;
